import React from 'react'

import type { IconType } from 'react-icons/lib'
import { twMerge } from 'tailwind-merge'

import Badge from '@/components/common/Badge'

import { SIDEBAR_OPTION_STYLES } from '@/constants/styles'

export type PageSidebarOption<T extends string> = {
  option: T
  icon: IconType
  count?: number
}

export interface PageSidebarProps<T extends string> {
  options: PageSidebarOption<T>[]
  selected: T
  onSelect: (option: T) => void
  buttonClassName?: string
  className?: string
}

const PageSidebar = <T extends string>({
  options,
  selected,
  onSelect,
  buttonClassName,
  className,
}: PageSidebarProps<T>) => {
  return (
    <div className={twMerge('flex flex-col w-full gap-y-1', className)}>
      {options.map(({ option, icon: Icon, count }, idx) => {
        return (
          <button
            key={idx}
            onClick={() => onSelect(option)}
            className={twMerge(
              option === selected
                ? 'bg-primary-200/70 dark:bg-primary-800'
                : '',
              SIDEBAR_OPTION_STYLES,
              'flex items-center justify-between',
              buttonClassName ?? '',
            )}
          >
            <div className="flex items-center gap-x-2">
              <Icon
                className="h-[18px] w-[18px] shrink-0 text-primary-600 dark:text-primary-400"
                aria-hidden="true"
              />
              <span className="text-sm text-primary-900 dark:text-primary-100">
                {option}
              </span>
            </div>
            {count !== undefined && count > 0 && <Badge count={count} />}
          </button>
        )
      })}
    </div>
  )
}

export default PageSidebar
